import * as rm from 'src/generated/api/rm.api';

type GetRoleList = rm.paths['/roles']['get'];
export type GetRoleListParams = GetRoleList['parameters']['query']['locale'];
export type GetRoleListResp = GetRoleList['responses']['200']['schema'];
